import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Two-line page header used app-wide for wayfinding.
// Small tracked-uppercase eyebrow names the SECTION (e.g. PEOPLE,
// PORTFOLIO, WORKSHEET). Below it, a clear page title (e.g. Capacity
// matrix). Optional right-side slot for controls (period selector,
// scenario toggle, primary action) and an optional back link that always
// sits in the same spot (top-left, aligned with the eyebrow).
//
// Usage:
//   <PageHeader section="PEOPLE" title="Capacity matrix" />
//   <PageHeader section="PORTFOLIO · ELLA LILLEY" title="2024_0335 · Chancery"
//               backTo="/portfolio" backLabel="Portfolio"
//               right={<PeriodSelector />} />
export default function PageHeader({ section, title, subtitle, right, backTo, backLabel }) {
  return (
    <header className="page-header" data-testid="page-header">
      <div className="page-header-copy">
        {backTo && (
          <Link
            to={backTo}
            className="eyebrow inline-flex items-center gap-1.5 mb-3 hover:text-[var(--ink)] transition-colors"
            data-testid="page-header-back"
          >
            <ArrowLeft size={11} />
            {backLabel || "Back"}
          </Link>
        )}
        {section && <div className="eyebrow" data-testid="page-header-section">{section}</div>}
        <h1 className="h-page mt-1.5" data-testid="page-header-title">{title}</h1>
        {subtitle && <div className="t-caption mt-2 max-w-2xl leading-relaxed">{subtitle}</div>}
      </div>
      {right && <div className="flex items-center gap-3 shrink-0" data-testid="page-header-right">{right}</div>}
    </header>
  );
}
